import { observer } from 'mobx-react';
import * as React from 'react';

export const EmptyComponent = observer(({ domain }) => {
  return <div />;
});
